// Leitura do `contentTiptap` (contrato do conteúdo Tiptap 1.0, seções 1 e 4).
// `readJSON` e `upgradeNode` espelham admin/src/components/Noticia/convertLegacyContent.js.
import { filePathFromUrl, safeFilePath } from './safeUrl'
import { warn } from './warn'

// null = vazio; undefined = não é JSON.
const readJSON = (value) => {
	if (value == null || value === '') return null
	if (typeof value !== 'string') return value
	try {
		return JSON.parse(value)
	} catch {
		return undefined
	}
}

// Parágrafo só com espaços e quebras. Mais defensivo que o do admin: o documento
// chega da API e pode trazer nós nulos ou texto que não é string.
const isBlankParagraph = node => Boolean(node) && node.type === 'paragraph' && (Array.isArray(node.content) ? node.content : [])
	.every(child => child && (child.type === 'hardBreak' || (child.type === 'text' && !(typeof child.text === 'string' ? child.text : '').trim())))

// Aninhamento além disso só vem de JSON forjado; parar evita estourar a pilha.
const MAX_DEPTH = 100

// Documentos gravados antes das regras 2.2 (C4) e 2.3 (W5) do contrato.
const upgradeNode = (node, depth = 0) => {
	if (!node || typeof node !== 'object') return node
	if (depth > MAX_DEPTH) throw new RangeError('Documento com aninhamento profundo demais.')
	let clean = node
	if (node.type === 'fileDownload' && node.attrs) {
		const { url, originalName, ...attrs } = node.attrs
		const path = attrs.path ? safeFilePath(attrs.path) : filePathFromUrl(url)
		clean = {
			...node,
			attrs: {
				...attrs,
				path,
				name: attrs.name || originalName || null,
			},
		}
	}
	// Links gravados antes do W5 levavam `target` e `rel` do padrão do Tiptap.
	if (Array.isArray(clean.marks) && clean.marks.some(mark => mark?.type === 'link')) {
		clean = {
			...clean,
			marks: clean.marks.map(mark => {
				if (mark?.type === 'link' && mark.attrs) {
					return {
						...mark,
						attrs: {
							...mark.attrs,
							target: null,
							rel: null,
							class: null,
						},
					}
				}
				return mark
			}),
		}
	}
	return Array.isArray(clean.content)
		? { ...clean, content: clean.content.map(node => upgradeNode(node, depth + 1)) }
		: clean
}

// Documento pronto para renderizar, ou null quando vale o `content` legado.
export const readTiptapDocument = (value) => {
	const doc = readJSON(value)
	if (doc === null) return null
	if (doc === undefined) {
		warn('contentTiptap não é um JSON válido; usando o conteúdo antigo.')
		return null
	}
	if (!doc || typeof doc !== 'object' || doc.type !== 'doc' || !Array.isArray(doc.content)) {
		// Só um resumo: o documento inteiro poluiria o console
		warn('contentTiptap não tem a raiz `doc`; usando o conteúdo antigo.', doc && typeof doc === 'object' ? { type: typeof doc.type } : typeof doc)
		return null
	}
	try {
		if (doc.content.every(node => isBlankParagraph(node))) return null
		return upgradeNode(doc)
	} catch (error) {
		warn('contentTiptap não pôde ser lido; usando o conteúdo antigo.', error instanceof Error ? error.message : undefined)
		return null
	}
}
